import { Component, OnInit } from '@angular/core';
import { UserSessionService } from 'src/app/user-session.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  standalone: false
})
export class DashboardComponent implements OnInit {
  role: string;
  access: boolean = false;
  private readonly rolesAllowed = [
    'MICROFINANCE',
    'MICROFINANCE_SUPERVISOR',
    'MICROFINANCE_CAISSE',
    'MICROFINANCE_COLLECTE',
    'MICROFINANCE_CREDIT'
  ];

  constructor(private userSessionService: UserSessionService) {

  }

  ngOnInit(): void {
    const roles = this.userSessionService.getUser()?.roles ?? [];
    this.access = roles.some(role => this.rolesAllowed.includes(role));
  }

}
